import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
} from 'reactstrap'
import styled from 'styled-components'

export const ConfirmSaveForm = (props) => {
  const { open, toggle, confirmSave } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <HeaderForm toggle={ () => toggle() }>
          <HeadLabel>Save Confirmation</HeadLabel>
        </HeaderForm>
        <ModalBody>
          Are you sure you want to save all changes ?
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={ () => confirmSave() }>Save</Button>
          <Button onClick={ () => toggle() }>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

ConfirmSaveForm.propTypes = {
  toggle: PropTypes.func,
  open: PropTypes.bool,
  confirmSave: PropTypes.func,
}
ConfirmSaveForm.defaultProps = {
  toggle: () => {},
  confirmSave: () => {},
  open: false,
}

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/confirm-save.js